module.exports = __webpack_public_path__ + "static/media/top-slide-2.1b5520de.jpeg";